
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';

@Component({
  templateUrl: './formFolderUrl.component.html',
  styleUrls: ['./formFolderUrl.component.scss']
})

export class FormFolderUrlComponent implements OnInit {  
  responseHolder: any;
  token: any;
  params: string;   
  urlParameter:any=[]=[];
  isMatched:boolean=false;
  formUrl:string="";
  successUrl:string="";
  declineUrl:string="";

  constructor(private router: Router,
    private route: ActivatedRoute, private formsService: FormsService,
    private loaderService: LoaderService) {       
  }

  ngOnInit(): void {    
    this.getQueryParameter();
  }
 
  getQueryParameter() {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];    
      this.matchFormFolderUrlParameter(params);
    });
  }  

  matchFormFolderUrlParameter(params){
    this.urlParameter=[];
    let myObject;
    myObject=params;
    for (let key in myObject) {
      if(myObject.hasOwnProperty(key)) {
        if(key != "token" && key != "type"){
          var obj={
            parameterName:key,
            value:myObject[key],
          }
          this.urlParameter.push(obj);
        }
      }
    }
    var ReqModel = {
      token:encodeURIComponent(decodeURIComponent(this.token)),
      urlParameters:this.urlParameter,      
    }
    this.loaderService.show();
    this.formsService.matchFormFolderUrlParameter(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.isMatched = this.responseHolder.data.isMatched;
        this.formUrl = this.responseHolder.data.formUrl;
        this.successUrl = this.responseHolder.data.successUrl;
        this.declineUrl = this.responseHolder.data.declineUrl;

        if(this.successUrl==null){
          this.successUrl="";
        }
        if(this.declineUrl==null){
          this.declineUrl="";
        }
        if(this.formUrl==null){
          this.formUrl="";
        }

        if(this.isMatched==false && this.declineUrl==''){
          this.router.navigate(['/request/declineurl']);
          this.loaderService.hide();
          return;
        }
        if(this.isMatched==false && this.declineUrl!=''){
           window.location.href=this.declineUrl;
           this.loaderService.hide();
           return;
        }
        if(this.isMatched==true && this.formUrl!=''){
           sessionStorage.setItem("formFolderSuccessurl", this.successUrl);         
           window.location.href=this.formUrl;
           this.loaderService.hide();
           return;         
        }
      }
       
    });
  }
  

}
